export default __webpack_public_path__ + "static/lars-7de88975fe7a424e097a5056bfef2960.png";